import classNames from 'classnames';

import Button from '../../shared/Button/Button';
import { Text } from '../../shared/Text/Text';
import PopUp from '../PopUp/PopUp';

interface ConfirmationPopupProps {
  isOpen: boolean;
  title: string;
  description?: string;
  handleConfirm: () => void;
  closePopup: () => void;
  variant?: 'success' | 'warning' | 'danger';
  confirmText?: string;
  popupIcon?: React.ReactNode;
}

export const ConfirmationPopup = ({
  isOpen,
  title,
  description,
  handleConfirm,
  closePopup,
  variant,
  confirmText = 'Confirm',
  popupIcon,
}: ConfirmationPopupProps) => {
  return (
    <PopUp isOpen={isOpen} variant={variant} handleClose={closePopup}>
      {popupIcon && <div className="absolute top-[20px] left-[12px]">{popupIcon}</div>}
      <div
        className={classNames(
          { ['max-w-[320px]']: !popupIcon },
          { ['max-w-[332px] ml-12']: popupIcon },
        )}
      >
        <Text.Bigger className="mb-4" weight="bold">
          {title}
        </Text.Bigger>

        <Text.Regular>{description}</Text.Regular>

        <div className="flex justify-center items-center gap-2 mt-4">
          <Button
            prefixIcon={<img alt={'check'} src={'/icons/check.svg'} />}
            label={confirmText}
            variant={variant}
            size="s"
            className="!w-36"
            onClick={handleConfirm}
          />
          <Button
            prefixIcon={<img alt={'close'} src={'/icons/close_outline.svg'} />}
            label="Cancel"
            variant="secondary"
            onClick={closePopup}
            className="!w-28"
            size="s"
          />
        </div>
      </div>
    </PopUp>
  );
};
